import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  location: string;
  text: string;
  image?: string;
}
export function TestimonialCard({
  name,
  location,
  text,
  image
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-xl shadow-sm border border-stone-100 flex flex-col h-full" data-id="element-12">
      <div className="flex gap-1 mb-4" data-id="element-13">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-[#eab308] text-[#eab308]" data-id="element-14" />)}
      </div>

      <p className="text-stone-700 italic mb-6 flex-grow text-sm leading-relaxed" data-id="element-15">
        "{text}"
      </p>

      <div className="flex items-center gap-3 mt-auto" data-id="element-16">
        <div className="w-10 h-10 rounded-full bg-stone-200 flex items-center justify-center text-stone-500 font-bold overflow-hidden" data-id="element-17">
          {image ? <img src={image} alt={name} className="w-full h-full object-cover" data-id="element-18" /> : name.charAt(0)}
        </div>
        <div data-id="element-19">
          <p className="font-bold text-stone-900 text-sm" data-id="element-20">{name}</p>
          <p className="text-xs text-stone-500" data-id="element-21">{location}</p>
        </div>
      </div>
    </div>;
}